import { Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
// @ts-ignore
import { getAccessToken } from '../auth';
import logoImg from '../images/logo/refer-refer-us.png';

interface Props {
  // Add any props you need here
}

interface BeforeInstallPromptEvent extends Event {
  prompt(): void;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;

const CustomPrompt: React.FC<Props> = () => {
  const [isInstalled, setIsInstalled] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  let isLoggedin = getAccessToken();


  const showCustomPrompt = (): void => {
    const addButton: HTMLElement | null = document.getElementById('add-to-home-screen-button');
    console.log("lets show prompt!")
    if (addButton) {
      addButton.addEventListener('click', () => {
        deferredInstallPrompt.prompt();

        deferredInstallPrompt.userChoice.then((choiceResult: { outcome: string }) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the prompt');
          } else {
            console.log('User dismissed the prompt');
          }
        });
      });
    }
  };

  useEffect(() => {
    const isAppInstalled = (): boolean => {
      return window.matchMedia('(display-mode: standalone)').matches;
    };

    setIsInstalled(isAppInstalled());

    window.addEventListener('beforeinstallprompt', (event: BeforeInstallPromptEvent) => {
      console.log("before install prompt!")
      event.preventDefault();
      deferredInstallPrompt = event;
      if(window?.location?.pathname === '/dashboard' && isLoggedin) {
        console.log("enable install prompt!")
        setShowPrompt(true);
      } else {
        setShowPrompt(false);
      }
      showCustomPrompt(); // Call the showCustomPrompt function here
      const modal: HTMLElement | null = document.getElementById('custom-prompt-modal');
      if (modal) {
        modal.style.display = 'block';
      }
      const addButton: HTMLElement | null = document.getElementById('add-to-home-screen-button');
      if (addButton) {
        addButton.addEventListener('click', () => {
          if (deferredInstallPrompt) {
            deferredInstallPrompt.prompt();
            deferredInstallPrompt.userChoice.then((choiceResult: { outcome: string }) => {
              if (choiceResult.outcome === 'accepted') {
                console.log('User  accepted the prompt');
              } else {
                console.log('User  dismissed the prompt');
              }
            });
          }
        });
      }
    });
  }, [window?.location]);

  const handleOk = () => {
    // Logic for adding to home screen can be added here
    if (deferredInstallPrompt) {
      deferredInstallPrompt.prompt();
      deferredInstallPrompt.userChoice.then((choiceResult: { outcome: string }) => {
        if (choiceResult.outcome === 'accepted') {
          setShowPrompt(false);
          console.log('User  accepted the prompt');
        } else {
          console.log('User  dismissed the prompt');
        }
      });
    }
  };

  return (
    <div>
      {showPrompt && (
        <Button
          onClick={() => handleOk()}
          style={{
            position: 'fixed',
            bottom: '5px',
            right: '8px',
            borderRadius: '8px',
            backgroundColor: '#F47523',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px',
          }}
        >
          <img
            src={logoImg} // Ensure the path is correct
            alt="Custom Icon"
            style={{ width: '60px', height: '70px', marginRight: '8px' }} // Adjust size as needed
          />
          <span className='desktop-view' style={{ fontSize: '16px' }}>Install ReferUs</span>
        </Button>
      )}
    </div>
  );
};

export default CustomPrompt;